export default __webpack_public_path__ + "static/media/relais-colis.509c3174.svg";